import React from "react";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { ConnectionButtonAppearance } from "@components/financialConnection/ConnectionActionButton";
import { FixConnectionButton } from "@components/financialConnection/FixConnectionButton";

interface Props extends ConnectionButtonAppearance {
    integrationConnection: IntegrationConnection;
    onFixed?: () => void;
    children: React.ReactNode;
}

export const FixIntegrationConnection: React.FC<Props> = ({
    integrationConnection,
    ...props
}) => <FixConnectionButton connection={integrationConnection} {...props} />;
